import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';

const DateList = ({
  id,
  name,
  label,
  //   value,
  defaultValue,
  multiple,
  onChange,
  sx,
  error,
  disabled,
}) => {
  const dates = Array.from({ length: 31 }, (_, i) => i + 1);
  const selectedValue = defaultValue || [];
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      disablePortal
      id={id}
      name={name}
      options={dates}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      disabled={disabled}
      multiple={multiple}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
        />
      )}
    />
  );
};

DateList.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  disabled: PropTypes.number,
  moderator: PropTypes.bool,
};
DateList.defaultProps = {
  multiple: false,
  sx: {},
  defaultValue: null,
  error: '',
  disabled: null,
  moderator: false,
};

export default DateList;
